import { IStateModel, StateModel } from '.';
import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IZipCode extends IModel {
  zipCodeId: number;
  zipcode: string;
  city: string;
  county: string;
  stateId: number;
  state: IStateModel;
  timezoneName: string;
}

export class ZipCode extends Model implements ModelRecord<IZipCode> {
  zipCodeId: number;
  zipcode: string;
  city: string;
  county: string;
  stateId: number;
  state: StateModel;
  timezoneName: string;
  constructor(params?: Partial<IZipCode>) {
    super(params);
    this.zipCodeId = defaultTo(params?.zipCodeId, 0);
    this.zipcode = defaultTo(params?.zipcode, '');
    this.city = defaultTo(params?.city, '');
    this.county = defaultTo(params?.county, '');
    this.stateId = defaultTo(params?.stateId, 0);
    this.state = params?.state
      ? new StateModel(params.state)
      : new StateModel();
    this.timezoneName = defaultTo(params?.timezoneName, '');
  }
}
